export default __webpack_public_path__ + "static/media/head.9c022353.jpg";